import React, { useContext, useEffect, useState } from 'react'
import { FormattedMessage, navigate, useIntl, Link } from 'gatsby-plugin-intl'
import { isEmpty } from 'ramda'
import MUIDropdownIcon from '@material-ui/icons/KeyboardArrowDown'
import {
  Actions,
  AuctionsMobile,
  Container,
  Delete,
  LocationFrom,
  LocationTo,
  Name,
  OfferNumber,
  Offeror,
  Refresh,
  Reservations,
  ReservationsMobile,
  ReservationStatusIcon
} from 'src/features/myOffers/components/atoms'
import {
  Arrow,
  DateTime,
  Ellipsis,
  GavelIcon
} from 'src/features/stocks/components/atoms'
import ArrowIcon from 'src/assets/icons/arrow-down.svg'
import CompanyIcon from 'src/assets/icons/work-case.svg'
import ContainerIcon from 'src/assets/icons/container.svg'
import { Avatar } from 'src/components/atoms/Avatar'
import { createOfferDetailsLink } from 'src/features/dashboard/duck/consts'
import DeleteIcon from 'src/assets/icons/delete.svg'
import PermissionsContext, {
  hasPermissionTo,
  PERMISSIONS
} from 'src/utils/permissions'
import ConfirmDialog from 'src/components/ConfirmDialog'
import {
  Company,
  Date,
  FreeCarrierTableRowFinished
} from 'src/features/reservations/components/atoms'
import { connectFreeCarrierFinishedReservations } from 'src/features/reservations/duck/connectors'
import { ReservationStatus } from 'src/features/myOffers/components/ReservationStatus'
import { RejectOfferPromptButton } from 'src/components/atoms/Buttons'
import { OFFER_TYPES } from 'src/features/offers/duck/consts'
import { ReservationDetailsOffer } from 'src/features/reservations/components/ReservationDetailsOffer'
import AuctionDetailsReservations from 'src/features/myOffers/components/AuctionDetailsReservations'
import MoneyIcon from 'src/assets/icons/money.svg'
import ActionsMenu, {
  DropdownItem
} from 'src/features/stocks/components/ActionsMenu'

const ReservationRowFinished = ({
  reservation,
  headers,
  currentUserId,
  cancelReservation,
  selectOfferForDebtCollection,
  setConversationOpened
}) => {
  const intl = useIntl()
  const [isOpen, setOpen] = useState(false)
  const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false)

  const permissions = useContext(PermissionsContext)
  const hasPermissionToSeeCompanyConversations = hasPermissionTo(
    PERMISSIONS.CHAT_COMPANY_CONVERSATIONS_SEE,
    permissions
  )
  const belongsToCurrentUser = reservation.offer.handler.id === currentUserId
  const chatAvailable =
    belongsToCurrentUser || hasPermissionToSeeCompanyConversations
  const isAuction = reservation.offer.type === OFFER_TYPES.AUCTION

  const handleClick = () => {
    setOpen(!isOpen)
  }

  useEffect(() => {
    isEmpty(reservation.reservations) && setOpen(false)
  }, [reservation.reservations])

  return (
    <>
      <FreeCarrierTableRowFinished
        key={reservation.id}
        numberOfHeaders={headers.length}
        isOpen={isOpen}
      >
        <ReservationStatusIcon>
          <ReservationStatus
            onlyIcon
            status={reservation.acceptedAt ? 'accepted' : 'rejected'}
          />
        </ReservationStatusIcon>
        <OfferNumber>
          <ReservationStatus
            onlyIcon
            status={reservation.acceptedAt ? 'accepted' : 'rejected'}
          />
          <Link to={createOfferDetailsLink(reservation.offer.referenceNumber)}>
            {reservation.offer.referenceNumber}
          </Link>
        </OfferNumber>
        <Reservations hasReservations={true} onClick={handleClick}>
          <span>
            <FormattedMessage id='myOffers.reservations' />
          </span>
          <MUIDropdownIcon
            width={24}
            height={24}
            style={{ transform: `rotate(${isOpen ? '180deg' : '0'})` }}
          />
        </Reservations>
        <LocationFrom>
          <Arrow>
            <ArrowIcon style={{ transform: 'rotate(270deg)' }} />
          </Arrow>
          {/* COUNTRY_CODES <Ellipsis>{`${reservation.offer.availabilityLocation.countryCode}, ${reservation.offer.availabilityLocation.name}`}</Ellipsis> */}
          <Ellipsis>{reservation.offer.availabilityLocation.name}</Ellipsis>
          <DateTime>
            {reservation.offer.availabilityDate}
            {reservation.offer.availabilityTime &&
              `, ${reservation.offer.availabilityTime}`}
          </DateTime>
        </LocationFrom>
        <LocationTo>
          {/* COUNTRY_CODES <Ellipsis>
            {reservation.offer.destinationLocation.name
              ? `${reservation.offer.destinationLocation.countryCode}, ${reservation.offer.destinationLocation.name}`
              : ''}
          </Ellipsis> */}
          <Ellipsis>{reservation.offer.destinationLocation.name}</Ellipsis>
        </LocationTo>
        <Container>
          <ContainerIcon />
          <div>
            <Ellipsis>{reservation.offer.containerSemiTrailer.name}</Ellipsis>
          </div>
        </Container>
        <Company>
          <CompanyIcon />
          <div>
            <Ellipsis>{reservation.offer.issuer.company.name}</Ellipsis>
          </div>
        </Company>
        <Offeror>
          <Avatar
            small
            url={reservation.offeror.avatar && reservation.offeror.avatar.url}
          />
          <Name>
            <Ellipsis>
              {`${reservation.offeror.firstName} ${reservation.offeror.lastName}`}
            </Ellipsis>
            <DateTime>
              <Ellipsis>{reservation.createdAtFormatted}</Ellipsis>
            </DateTime>
          </Name>
          {isAuction && <GavelIcon />}
        </Offeror>
        <Date>
          <DateTime>
            <Ellipsis>{reservation.createdAtFormatted}</Ellipsis>
          </DateTime>
          {(reservation.isCancellable ||
            reservation.offer.isDebtCollectable) && (
            <ActionsMenu>
              {reservation.isCancellable && (
                <DropdownItem
                  onClick={e => {
                    e.stopPropagation()
                    setDeleteDialogOpen(true)
                  }}
                >
                  <DeleteIcon />
                  <FormattedMessage id='reservations.cancelReservation' />
                </DropdownItem>
              )}
              {reservation.offer.isDebtCollectable && (
                <DropdownItem
                  onClick={e => {
                    e.stopPropagation()
                    selectOfferForDebtCollection(reservation.offer)
                  }}
                >
                  <MoneyIcon />
                  <FormattedMessage id='reservations.debtCollection' />
                </DropdownItem>
              )}
            </ActionsMenu>
          )}
        </Date>
        {(reservation.isCancellable || reservation.offer.isDebtCollectable) && (
          <Actions>
            {reservation.isCancellable && (
              <Delete onClick={() => setDeleteDialogOpen(true)}>
                <DeleteIcon />
              </Delete>
            )}
            {reservation.offer.isDebtCollectable && (
              <Refresh
                onClick={() => selectOfferForDebtCollection(reservation.offer)}
              >
                <MoneyIcon />
              </Refresh>
            )}
          </Actions>
        )}
      </FreeCarrierTableRowFinished>
      {!isAuction && (
        <ReservationsMobile onClick={handleClick} isOpen={isOpen}>
          <span>
            <FormattedMessage id='reservations.win' />
          </span>
          <MUIDropdownIcon
            width={24}
            height={24}
            style={{ transform: `rotate(${isOpen ? '180deg' : '0'})` }}
          />
        </ReservationsMobile>
      )}
      {isAuction && (
        <AuctionsMobile onClick={handleClick} isOpen={isOpen}>
          <GavelIcon />
          <span>
            <b>
              <FormattedMessage id='reservations.win' />
            </b>
          </span>
          <MUIDropdownIcon
            width={24}
            height={24}
            fontSize='small'
            style={{ transform: `rotate(${isOpen ? '180deg' : '0'})` }}
          />
        </AuctionsMobile>
      )}
      {isOpen && !isAuction && (
        <ReservationDetailsOffer
          open={isOpen}
          offer={reservation.offer}
          chatAvailable={chatAvailable}
          setConversationOpened={() => {
            setConversationOpened({
              receiverId: reservation.offer.handler.id,
              contextId: reservation.offer.id,
              contextType: reservation.offer.offerContextType,
              conversationOpened: true
            })
          }}
        />
      )}
      {isOpen && isAuction && (
        <AuctionDetailsReservations
          reservation={reservation}
          isOpen={isOpen}
          offer={reservation.offer}
          chatAvailable={chatAvailable}
          setConversationOpened={() => {
            setConversationOpened({
              receiverId: reservation.offer.handler.id,
              contextId: reservation.offer.id,
              contextType: reservation.offer.offerContextType,
              conversationOpened: true
            })
          }}
        />
      )}
      <ConfirmDialog
        withReason
        confirmButton={RejectOfferPromptButton}
        open={isDeleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        offer={reservation.offer}
        onConfirm={reason =>
          cancelReservation({
            offerId: reservation.offer.id,
            reservationId: reservation.id,
            reason
          })
        }
        onOfferNumberClick={() =>
          navigate(createOfferDetailsLink(reservation.offer.referenceNumber))
        }
        message={
          <FormattedMessage
            id='reservations.cancelReservationWarning'
            values={{
              name: reservation.offer.referenceNumber
            }}
          />
        }
        title={<FormattedMessage id='reservations.cancelReservationTitle' />}
        inputTitle={intl.formatMessage({
          id: 'myOffers.rejectSoldInputTitle'
        })}
        inputPlaceholder={intl.formatMessage({
          id: 'myOffers.rejectSoldInputPlaceholder'
        })}
      />
    </>
  )
}

export default connectFreeCarrierFinishedReservations(ReservationRowFinished)
